import Vue from 'vue'
import trackField from '@/infrastructure/directive/track-field'
import clickOutside from '@/infrastructure/directive/click-outside'

Vue.directive('readMore', {
  inserted: function refreshTextOverflow (el) {
    /* eslint-disable no-undef */
    Utils.setOverflowTextMaxLines()
  }
})

Vue.directive('click-outside', clickOutside)

Vue.directive('track-field', trackField)
